import React from 'react';
import PropTypes from 'prop-types';

import './InfoToastMessage.theme.scss';

export function InfoToastMessageTitle({ title }) {
  return (
    <div className="info-toast-message__title">{title}</div>
  );
}

InfoToastMessageTitle.propTypes = {
  title: PropTypes.string,
};

export const InfoToastMessageContent = ({ content }) => {
  return (
    <div className="info-toast-message__content">{content}</div>
  );
};

InfoToastMessageContent.propTypes = {
  content: PropTypes.string,
};
